<template>
  <div id="paginaStoricoSoggetto">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Storico Soggetto</b-card-title>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="1" md="1">
                <label for="soggetto" class="h5 mb-0 mt-1">Soggetto</label>
              </b-col>
              <b-col xl="6" md="6" class="mb-2">
                <ejs-dropdownlist
                  id="soggetto"
                  ref="soggetto"
                  v-model="soggettoCorrente"
                  :dataSource="elencoSoggettiList"
                  :fields="elencoSoggettiFields"
                  :allowFiltering="true"
                  :filtering="soggettoFiltering"
                  :itemTemplate="itemTemplate"
                  :valueTemplate="valueTemplate"
                  :change="onSoggettoChange"
                  />
              </b-col>
              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <div id="GridParent">
                  <ejs-grid
                    id="gridA"
                    ref="gridA"
                    :dataSource="soggettoFullData"
                    :height="gridA.height"
                    :allowFiltering="true"
                    :filterSettings="gridA.filterOptions"
                    :allowGrouping="true"
                    :groupSettings="gridA.groupOptions"
                  >
                    <e-columns>
                      <e-column field="id" headerText="ID" :isPrimaryKey="true" width="40"></e-column>
                      <e-column field="spettacoloName" headerText="Spettacolo" width="150"></e-column>
                      <e-column field="descrizione" headerText="Descrizione" width="80"></e-column>
                      <e-column
                        field="categoria" headerText="Categoria" width="80"
                        foreignKeyField="id" foreignKeyValue="label" :dataSource="this.categoriaList"
                      ></e-column>
                      <e-column field="importo" headerText="Importo" width="70" ></e-column>
                      <e-column field="pagato" headerText="Pagato" width="50"></e-column>
                      <e-column field="ruolo" headerText="Ruolo" width="70"></e-column>
                      <e-column field="numGiorniRecite" headerText="Num Recite" width="50"></e-column>                      
                    </e-columns>
                    <e-aggregates>
                      <e-aggregate>
                        <e-columns>
                          <e-column
                            type="Sum"
                            field="importo"
                            format="Tot € ######.##"
                          ></e-column>
                        </e-columns>
                      </e-aggregate>
                    </e-aggregates>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  LinkPlugin,
  AlertPlugin,
  ProgressPlugin,
  ToastPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Vuexy
// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { Query } from "@syncfusion/ej2-data";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
} from "@syncfusion/ej2-vue-inputs";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Aggregate,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(LayoutPlugin);
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(DropdownPlugin);
Vue.use(DatePickerPlugin);
Vue.use(ButtonPlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(SpinnerPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT;
const apiSoggettiUrl = "/demo/api/soggetto"
const apiStoricoSoggettoUrl = "/demo/api/soggetto/storico_soggetto"

// TODO: usare flex?
var itemVue = Vue.component("itemTemplate", {
  template: `<span><span style='display:inline-block;margin-right: 30px;' class='denominazione'>{{data.denominazione}}</span><span class ='codFisc'>{{data.codiceFiscale}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

var valueVue = Vue.component("valueTemplate", {
  template: `<span><span class='denominazione'>{{data.denominazione}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      loading: false,
      // per gestione stagioni
      queryStagioni: null,
      stagioneCorrente: null,
      // per gestione spettacoli
      elencoSoggettiList: [],
      elencoSoggettiFields: { text: "denominazione", value: "id" },
      soggettoFullData: [],
      categoriaList: [
        { label: "Scrittura", id: "scrittura" },
        { label: "Altra Scrittura", id: "altrascrittura" },
        { label: "Allestimento", id: "allestimento" },
        { label: "Altra Spesa", id: "altraspesa" },
      ],
      soggettoCorrente: null,

      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: valueVue };
      },

      // generali
      settings: {
        formatoData: "dd-MM-yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
        firstDayOfWeek: 1,
      },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        filterOptions: { type: "Excel" },
        groupOptions: { showDropArea: false, columns: ["categoria"] },
      }, //
    };
  },
   created() {
    // log
    console.log("Pagina Storico soggetto Creata");
    // soggetti filtrati (artisti e tecnici)
    useJwt.get(apiSoggettiUrl).then((d) => {
      this.elencoSoggettiList = d.data
    });

  },
  mounted() {

  },

  provide: {
    // per grid
    grid: [
      GridToolbar,
      GridSort,
      GridFilter,
      GridEdit,
      ForeignKey,
      Group,
      Aggregate,
    ],
  },
  methods: {
    // per elenco soggetti: filtra la digitazione per cognome
    soggettoFiltering: function (e) {
      var searchData = this.elencoSoggettiList;
      var query = new Query();
      // puoi usare contains, startsWith, or endsWith
      query = e.text != "" ? query.where("denominazione", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    // aggiorna onSoggettoChange
    async onSoggettoChange() {
        let datiDaInviare = {id: this.soggettoCorrente}
        const r = await useJwt.post(apiStoricoSoggettoUrl, datiDaInviare).then((d) => {
            this.soggettoFullData = d.data
        })
        console.log(this.soggettoFullData)
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
  computed: {
    hasChanged() {
      // console.log(this.allestimentiActiveData)
      // console.log(this.allestimentiSavedData)
      return Object.keys(this.allestimentiActiveData).some(
        (field) =>
          this.allestimentiActiveData[field] !==
          this.allestimentiSavedData[field]
      );
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
